import React from 'react';
import Style from './formPreview.module.css';
import { InputLabel, InputSublabel, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import UploadFileZone from '../../../components/upload/uploadFileZone';
import useAppContext from '../../../context/useAppContext';
import { getWeezFileUrl } from '../../../components/upload/utils';

export default function FormFile({ field, label, value = null, id = null, onChangeForm = () => {} }) {
    const toast = React.useContext(ToastContext);
    const [{ organization }] = useAppContext();
    const { t } = useTranslation();

    const onChange = React.useCallback(
        v => {
            if (id) {
                onChangeForm(id, v);
            }
        },
        [id]
    );

    const fileUrl = React.useMemo(() => {
        return getWeezFileUrl(value, window.weezConfig.aws.weez_bucket_form);
    }, [value]);

    const onError = React.useCallback(e => {
        toast.error(t('nacre.previewFile.error.loading'));
        console.error(e);
    });

    return (
        <div className={Style['field']}>
            <UploadFileZone
                className={Style['form-file__upload-zone']}
                organization={organization}
                fileTypes={UploadFileZone.defaultFileTypes}
                onUpload={file => onChange(file.url)}
                onError={onError}
                title={<InputLabel label={label} required={field.required} />}
                subtitle={field.form_field.description && <InputSublabel label={field.form_field.description} />}
                labelDropzone={t('ticket.form.preview.file.label')}
                maxSize={2097152}
                file={fileUrl}
                onDelete={() => onChange(null)}
            />
        </div>
    );
}
